import isFn from './isFn'

export default function rm(arr, fn) {
  if (isFn(fn)) {
    return arr.filter((...args) => (! fn(...args)))
  }
  const value = fn
  return arr.filter(elem => (elem !== value))
}
